function getDomain() {
    return process.env.REACT_APP_SCORZA_AUTH_URL;
}

const apiDomain = getDomain();

export { apiDomain };
